import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { AboutMeContactInformationComponent } from "./about-me/about-me-detail/about-me-contact-information/about-me-contact-information.component";
import { AboutMeDetailComponent } from "./about-me/about-me-detail/about-me-detail.component";
import { AboutMeEgiftPurchasesComponent } from "./about-me/about-me-detail/about-me-egift-purchases/about-me-egift-purchases.component";
import { AboutMeEgiftReceivedComponent } from "./about-me/about-me-detail/about-me-egift-received/about-me-egift-received.component";
import { AboutMePaymentMethodsComponent } from "./about-me/about-me-detail/about-me-payment-methods/about-me-payment-methods.component";
import { AboutMeSubscriptionsComponent } from "./about-me/about-me-detail/about-me-subscriptions/about-me-subscriptions.component";
import { AboutMeVenueDetailComponent } from "./about-me/about-me-detail/about-me-venues/about-me-venue-detail/about-me-venue-detail.component";
import { AboutMeVenueVisitListComponent } from "./about-me/about-me-detail/about-me-venues/about-me-venue-detail/about-me-venue-visit-list/about-me-venue-visit-list.component";
import { AboutMeVenuesComponent } from "./about-me/about-me-detail/about-me-venues/about-me-venues.component";
import { AboutMeHeaderComponent } from "./about-me/about-me-header/about-me-header.component";
import { AboutMeLoginComponent } from "./about-me/about-me-login/about-me-login.component";
import { AboutMeValidationComponent } from "./about-me/about-me-login/about-me-validation/about-me-validation.component";
import { AboutMeComponent } from "./about-me/about-me.component";

@NgModule({
	declarations: [
		AboutMeComponent,
		AboutMeLoginComponent,
		AboutMeVenuesComponent,
		AboutMeDetailComponent,
		AboutMeHeaderComponent,
		AboutMeValidationComponent,
		AboutMePaymentMethodsComponent,
		AboutMeContactInformationComponent,
		AboutMeEgiftPurchasesComponent,
		AboutMeEgiftReceivedComponent,
		AboutMeSubscriptionsComponent,
		AboutMeVenueDetailComponent,
		AboutMeVenueVisitListComponent,
	],
	imports: [SharedModule],
})
export class CustomerModule {}
